module.exports = __webpack_public_path__ + "images/emoji/kissing.be48621e49c8dbf696be.png";